/* GTU Proudly Made — cleaned, minimal implementation
   - Icons: data-target="key" or data-index="N"
   - Panels: data-key="key"
   - Optional default: data-default="true"
*/
(function () {
  'use strict';

  const ICON_ACTIVE_CLASS = 'gtu-proudly-made-icon-active';
  const BLOCK_ACTIVE_CLASS = 'active';

  const SELECTORS = {
    desktopIcons: '.gtu-proudly-made-section-symbol-details [data-target], .gtu-proudly-made-section-symbol-details [data-index]',
    mobileIcons: '.gtu-proudly-made-section-symbol-details-mobile [data-target], .gtu-proudly-made-section-symbol-details-mobile [data-index]',
    desktopBlocks: '.gtu-proudly-made-section-content-last-main-container .gtu-proudly-made-section-content-win',
    mobileBlocks: '.gtu-proudly-made-section-content-last-main-mobile .gtu-proudly-made-section-content-win'
  };

  const $all = (selector, root = document) => Array.prototype.slice.call(root.querySelectorAll(selector));

  const findIndexByKey = (blocks, key) => (blocks && key) ? blocks.findIndex(b => b.getAttribute('data-key') === key) : -1;
  const findDefaultIndex = blocks => (blocks && blocks.length) ? blocks.findIndex(b => b.getAttribute('data-default') === 'true') : -1;

  const activate = (blocks, idx) => {
    if (!blocks || !blocks.length) return;
    const total = blocks.length;
    blocks.forEach((b, i) => {
      b.classList.toggle(BLOCK_ACTIVE_CLASS, i === idx);
      const count = b.querySelector('.gtu-proudly-made-section-content-win-count-mobile');
      if (i === idx && count) count.textContent = `${idx + 1} of ${total}`;
    });
  };

  const getIndexForIcon = (icon, blocks) => {
    if (!icon) return -1;
    const key = icon.getAttribute('data-target');
    if (key && blocks) {
      const k = findIndexByKey(blocks, key);
      if (k !== -1) return k;
    }
    const n = parseInt(icon.getAttribute('data-index'), 10);
    return Number.isFinite(n) ? n - 1 : -1;
  };

  const bindIcons = (icons, blocks) => {
    // kept for backward-compat but we prefer event delegation in bindGroup
    if (!icons.length || !blocks.length) return;
    icons.forEach(icon => icon.style.cursor = 'pointer');
  };

  const bindGroup = (iconsSel, blocksSel) => {
    const icons = $all(iconsSel);
    const blocks = $all(blocksSel);
    if (!icons.length || !blocks.length) return;

    // set cursor for icons
    bindIcons(icons, blocks);

    // attach click listener via delegation to the icon container (more robust on mobile)
    const containerSelector = iconsSel.includes('mobile') ? '.gtu-proudly-made-section-symbol-details-mobile' : '.gtu-proudly-made-section-symbol-details';
    const iconsContainer = document.querySelector(containerSelector);
    if (iconsContainer) {
      iconsContainer.addEventListener('click', (e) => {
        const svg = e.target.closest('svg[data-target], svg[data-index]');
        if (!svg) return;
        const idx = getIndexForIcon(svg, blocks);
        if (idx < 0 || idx >= blocks.length) return;

        // activate matching block
        activate(blocks, idx);

        // determine active key from block (prefer key-based mapping)
        const activeKey = blocks[idx].getAttribute('data-key');

        // toggle icon active states reliably (compare keys first, then numeric index)
        icons.forEach(i => {
          const ikey = i.getAttribute('data-target');
          const iidx = parseInt(i.getAttribute('data-index'), 10);
          const matches = (ikey && activeKey && ikey === activeKey) || (Number.isFinite(iidx) && iidx - 1 === idx);
          i.classList.toggle(ICON_ACTIVE_CLASS, !!matches);
          // Ensure SVG paths get the correct fill to avoid inline-fill vs css conflicts
          const paths = i.querySelectorAll('path');
          paths.forEach(p => p.style.fill = matches ? '#dc2028' : '#B2B3B7');
        });

        // optional background swap: if the icon has data-bg, update the content container and section-level containers
        const bg = svg.getAttribute('data-bg');
        const isMobile = iconsSel.includes('mobile');
        const contentContainer = document.querySelector(isMobile ? '.gtu-proudly-made-section-content-last-main-mobile' : '.gtu-proudly-made-pedigree-stage');
  const containerMobileAlt = document.querySelector('.gtu-proudly-made-car-bg-mobile') || document.querySelector('.gtu-proudly-made-section-content-last-main-container-mobile');
        const applyBg = (el) => {
          if (!el) return;
          if (bg) {
            el.style.backgroundImage = `url('${bg}')`;
          } else {
            el.style.backgroundImage = '';
          }
        };
        if (isMobile) {
          applyBg(containerMobileAlt);
        } else {
          applyBg(contentContainer);
        }
      });
    }

    // apply default if present
    const defaultIdx = findDefaultIndex(blocks);
    if (defaultIdx >= 0) {
      activate(blocks, defaultIdx);
      const activeKey = blocks[defaultIdx].getAttribute('data-key');
      icons.forEach(i => {
        const ikey = i.getAttribute('data-target');
        const iidx = parseInt(i.getAttribute('data-index'), 10);
        const matches = (ikey && activeKey && ikey === activeKey) || (Number.isFinite(iidx) && iidx - 1 === defaultIdx);
        i.classList.toggle(ICON_ACTIVE_CLASS, !!matches);
        const paths = i.querySelectorAll('path');
        paths.forEach(p => p.style.fill = matches ? '#dc2028' : '#B2B3B7');
      });
      // set background for default icon if provided (apply to content and section-level containers)
      const defaultIcon = icons.find(i => i.classList.contains(ICON_ACTIVE_CLASS));
      if (defaultIcon) {
        const bg = defaultIcon.getAttribute('data-bg');
        const isMobile = iconsSel.includes('mobile');
        const contentContainer = document.querySelector(isMobile ? '.gtu-proudly-made-section-content-last-main-mobile' : '.gtu-proudly-made-pedigree-stage');
  const containerMobileAlt = document.querySelector('.gtu-proudly-made-car-bg-mobile') || document.querySelector('.gtu-proudly-made-section-content-last-main-container-mobile');
        const applyBg = (el) => {
          if (!el) return;
          if (bg) {
            el.style.backgroundImage = `url('${bg}')`;
          } else {
            el.style.backgroundImage = '';
          }
        };
        const isMobileDefault = iconsSel.includes('mobile');
        if (isMobileDefault) {
          applyBg(containerMobileAlt);
        } else {
          applyBg(contentContainer);
        }
      }
    } else {
      blocks.forEach(b => b.classList.remove(BLOCK_ACTIVE_CLASS));
    }
  };

  const init = () => {
    bindGroup(SELECTORS.desktopIcons, SELECTORS.desktopBlocks);
    bindGroup(SELECTORS.mobileIcons, SELECTORS.mobileBlocks);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();